import axios, { AxiosHeaders } from 'axios';
import { fetchAuthSession }   from 'aws-amplify/auth';
import { observeApiResponse } from '../utils/conversions';

const apiAxios = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:8080"
});

apiAxios.interceptors.request.use(
    async (config) => {
        try {
            const { tokens } = await fetchAuthSession();
            const rawToken  = tokens?.idToken?.toString();
            if (rawToken) {
                // Turn whatever headers you already have into an AxiosHeaders
                const headers = new AxiosHeaders(config.headers);
                // Use the `set` method
                headers.set('Authorization', `Bearer ${rawToken}`);
                // Re-assign the headers field back to your config
                config.headers = headers;
            }
        } catch (err) {
            console.warn('fetchAuthSession failed', err);
        }
        return config;
    },
    (error) => Promise.reject(error)
);

/*
 * Funnel milestones are read off successful responses rather than raised by the
 * components that make the calls.
 *
 * "The account created its first project" is a fact the server establishes, and
 * observing it here covers every caller — including the ones that will exist
 * later — instead of relying on each form to remember to report it. The trial is
 * only ever visible as fields on a subscription response; nothing announces it.
 *
 * observeApiResponse guards itself against firing twice, and the try/catch is
 * belt-and-braces: an analytics mistake must never turn a working API call into a
 * rejected promise.
 */
apiAxios.interceptors.response.use(
    (response) => {
        try {
            observeApiResponse(
                response.config?.method,
                response.config?.url,
                response.status,
                response.data
            );
        } catch {
            // Never let instrumentation break the request it was measuring.
        }
        return response;
    },
    (error) => Promise.reject(error)
);

export default apiAxios;